import { render } from "./RightAlignedEventDetails.vue?vue&type=template&id=5acd7234&scoped=true"
import script from "./RightAlignedEventDetails.vue?vue&type=script&lang=js"
export * from "./RightAlignedEventDetails.vue?vue&type=script&lang=js"

import "./RightAlignedEventDetails.vue?vue&type=style&index=0&id=5acd7234&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acd7234"]])

export default __exports__